var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack389({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.76,10.73V5H5.38a3,3,0,0,1,.91.11,1.45,1.45,0,0,1,.71.5,2.52,2.52,0,0,1,.47.91,4.63,4.63,0,0,1,.17,1.31,4.25,4.25,0,0,1-.28,1.65,1.93,1.93,0,0,1-.74,1,2.13,2.13,0,0,1-1.17.29Zm.62-.68h1a1.68,1.68,0,0,0,.92-.2,1.27,1.27,0,0,0,.48-.63A3.86,3.86,0,0,0,7,7.83a3.18,3.18,0,0,0-.24-1.37,1.25,1.25,0,0,0-.6-.67,2,2,0,0,0-.8-.11h-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.5,10.73V5h2.09a2.16,2.16,0,0,1,1,.16,1.25,1.25,0,0,1,.51.53,1.86,1.86,0,0,1,.2.87,1.46,1.46,0,0,1-1.32,1.56,1.51,1.51,0,0,1,.4.32,4.19,4.19,0,0,1,.48.73l.82,1.56h-.78l-.62-1.19a8.45,8.45,0,0,0-.55-.94,1.17,1.17,0,0,0-.36-.33,1.1,1.1,0,0,0-.49-.09H9.12v2.55Zm.62-3.2h1.34a1.61,1.61,0,0,0,.66-.11.72.72,0,0,0,.36-.33,1,1,0,0,0,.14-.53.91.91,0,0,0-.26-.68,1.06,1.06,0,0,0-.75-.25H9.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack389);
export default __webpack_public_path__ + "static/media/Symbol_pack_389.4d8db98f594d42cc6d8b76fa43c66f7b.svg";
export { ForwardRef as ReactComponent };